import type { Filter } from 'components/filters/useStreamFilters'

export function shouldPersistStreamHeader(filter?: Filter) {
    return !filter?.questId && !filter?.participants
}
